module.exports = __webpack_public_path__ + "static/studio-08-f7ed007218c9544047c8e1de8f345b0c.png";